<template>
    <div class="h-100">
        <!--Service D'alert -->
        
  <div class="container alertForm w-100" v-if="alertForm">

        <div class="row d-flex justify-content-end">
        <div class="col-md-8 col-lg-6 col-xl-4">

            <div class="card chat1">
            <div
                class="card-header d-flex justify-content-between align-items-center p-3 bg-dark text-white border-bottom-0 " id="chat2">
                <p class="mb-0 fw-bold">Alerte</p>
                <i class="fas fa-times" @click="alertForm=false"></i>
            </div>
                <div class="container-fluid w-100">
                <div class="d-flex flex-row justify-content-start w-100">
                <div class="pt-3 pb-1 w-100">
                    <label for="">Niveau d'urgence</label>
                </div>
                </div>
                <div class="d-flex flex-row justify-content-start mb-2 w-100">
                <div class="py-1 w-100">
                    <select name="" id="" class="p-2 w-100 border rounded">
                        <option value="1">1</option>  
                        <option value="2">2</option> 
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                    </select>
                </div>
                </div>

                <div class="d-flex flex-row justify-content-start w-100">
                <div class="pt-3 pb-1 w-100">
                    <label for="">Patient</label>
                </div>
                </div>
                <div class="d-flex flex-row justify-content-start mb-2 w-100">
                <div class="py-1 w-100">
                    <select name="" id="" class="p-2 w-100 border rounded">
                        <option value="1">piere</option>  
                        <option value="2">paul</option> 
                        <option value="3">nono</option>
                        <option value="4">belthold</option>
                        <option value="5">Clive</option>
                    </select>
                </div>
                </div>
                <div class="d-flex flex-row justify-content-start w-100">
                    <div class="pt-3 pb-1 w-100">
                        <label for="">Plainte</label>
                    </div>
                </div>
                <div class="form-outline pb-1">
                    <textarea class="form-control" id="textAreaExample" rows="5"></textarea>
                </div>
                <div class="pt-3 pb-3 w-100">
                    <span class="btn btn-primary w-100">Envoyer</span>
                </div>

            </div>
            </div>
        </div>
        </div>

        </div>
        <!-- <div class="myAlert" @click="alertForm= true">
            <i class="fa fa-exclamation-triangle fixAlerte"></i>
            
            <div class="alertMessage">Cliquez pour ajouter une alerte.</div>
        </div> -->
        
        <!--Première étape Pour un Nouveau souscripteur sur medsurlink -->
        <div v-if="newSubscribers">
            <WelcomeMedsurlink @getHome="Home=true,oldSubscribers=false"/>
        </div>
        <!--Première étape Pour un Ancien souscripteur avec aumoins une CIM sur medsurlink -->
        
        <div v-if="ifRestant && oldSubscribers && !newSubscribers">
            <oldSubcriber @getHome="Home=true,oldSubscribers=false"/>
        </div>
        
        <div class="" v-if="!ifRestant || Home">
            <div class="">
                
                <b-container class="p-0">
                    <div class="my-2 py-2 d-flex justify-content-end">
                        <b-button @click="gotToMesAffilies" variant="" class="text-primary sub-primary ml-2 shadow-none">
                            {{ $t('message.mesAffilie') }}
                        </b-button>
                        <b-button @click="goToPaiement" variant="" class="text-primary sub-primary ml-2 shadow-none">
                            {{ $t('message.subscribe') }}
                        </b-button>
                    </div>

                    <b-row v-if="!mobileView" class="souscripteur card shadow">
                        <ul class="souscripteur_thead row w-100">
                            <li class="col text-left">{{ $t('message.produits') }}</li>
                            <li class="col text-center">{{ $t('message.numberpaid') }}</li>
                            <li class="col text-center">{{ $t('message.numberstay') }}</li>
                            <li class="col text-center">{{ $t('message.unitaire') }}</li>
                            <li class="col text-center">{{ $t('message.creationDate') }}</li>
                            <li class="col text-center">Factures</li>
                            <li class="col text-center"></li>
                        </ul>
                        <div v-for="(cmd,index) in mCommandes" :key="index">
                            <ul class="souscripteur_tbody row pb-1" v-if="mCommandes.length>0">
                                <li class="col-2 text-left">{{ cmd.type_contrat.description_fr.length > 40 ? cmd.type_contrat.description_fr.substring(0, 40)+' ...' : cmd.type_contrat.description_fr }}</li>
                                <li class="col text-center">{{cmd.nombre_paye}}</li>
                                <li class="col text-center">{{cmd.nombre_restant}}</li>
                                <li class="col text-center">{{cmd.type_contrat.montant}} </li>
                                <li class="col text-center">{{ new Date(cmd.created_at).toLocaleString().split(",")[0] }} </li>
                                
                                <li class="col text-center">
                                    <b-link variant="primary" @click="GenerationFacture(cmd)">
                                        <button class="bg-primary text-white border-0 border-primary rounded">
                                                <i class="fa fa-print"></i> 
                                        </button>
                                    </b-link>
                                </li>
                                <li class="btn-toggle col text-center">
                                    <b-button v-b-toggle="'collapse'+index" variant="primary" 
                                    @click="rotation(index)">
                                        <i class="fa" aria-hidden="true" 
                                        :class="rotate ? 'fa-chevron-down' : 'fa-chevron-up'" :id="'rotat'+index"></i>
                                    </b-button>
                                </li>
                            </ul>
                            <ul class="d-block m-0">
                                <b-collapse :id="'collapse'+index" class="mt-2" :class="rotate ? 'bg-secondary p-4 patient_info' : ''">
                                    <li class="p-3 w-50 patient_qtity"
                                      v-if="cmd.nombre_restant > 1">
                                        {{cmd.nombre_restant}} patients restant à ajouter !
                                    </li>
                                    <li class="patient_qtity-1 p-3 w-50"
                                      v-else>
                                        {{cmd.nombre_restant}} patients restant à ajouter !
                                    </li>
                                    <!-- <h3 class="mt-2">Patient Information</h3> -->
                                    {{ $t('message.addPatient') }} <br>
                                    <router-link class="btn btn-primary text-white shadow my-4" id="disabled-wrapper"  :to="{ name: 'add-patient-souscripteur',params:{id: cmd.id, texte:cmd.type_contrat.description_fr} }" v-if="can || hasPraticienRole || hasSouscripteurRole || hasMedecinControleRole">
                                        Add Patient
                                    </router-link>
                                </b-collapse>
                            </ul>
                        </div>
                    </b-row>
                    <b-row v-else class="container-fluid content__trajet w-100">
                       
                        <h3 class="text-center mb-2 ml-2 title">
                            {{ $t('message.SouscripteurDashboard') }}
                        </h3>

                            <div class="row w-100">
                            <div class=" mt-3 w-100" v-for="(value, index) in all_commandes" :key="index"> 
                                <div v-if="value.nombre_restant > 0">
                                <div v-b-toggle="'collapse'+index" class="trajet__info trajet__active w-100" v-if="value.nombre_restant > 0"> 
                                    <span class="border border-5 rounded py-1 px-1 row  cimdashboard">
                                       
                                        <div class="col-6 text-default"> 
                                            <h5>{{truncate(value.type_contrat.description_fr, 25) }}</h5>
                                        </div>
                                        <div class="col-6 pt-1">
                                                <span class="border border-secondary transparentRed rounded text-red py-1 px-3 float-right">Incomplet</span>
                                        </div>
                                    </span>
                                </div>
                                <b-collapse :id="'collapse'+index" class="">
                                    <div>
                                        <div class="py-1">

                            <div class="mt-2 card-body shadow">
                                <div class="list-group-item"><p class="ligne pt-3"><span class="new-title">Produits</span>: <span class="font-weight-bold text-gray float-right">{{ value.type_contrat.description_fr.length > 21 ? value.type_contrat.description_fr.substring(0, 21)+' ...' : value.type_contrat.description_fr }}</span></p></div>
                                <div class="list-group-item"><p class="ligne"><span class="new-title">Nombre payé</span><span class="font-weight-bold text-gray float-right">{{value.nombre_paye}}</span></p></div>
                                <div class="list-group-item"><p class="ligne"><span class="new-title">Nombre restant</span>: <span class="font-weight-bold text-gray float-right">{{value.nombre_restant}}</span></p></div>
                                <div class="list-group-item"><p class="ligne"><span class="mr-2 new-title">Montant unitaire: </span><span class="font-weight-bold text-gray float-right">{{value.type_contrat.montant}}</span></p></div>
                                <div class="list-group-item"><p class="ligne"><span class="new-title">Date de création</span>: <span class="font-weight-bold text-gray float-right">{{ new Date(value.created_at).toLocaleString().split(",")[0] }}</span></p></div>
                                <div class="list-group-item justify-content-center pt-5 pb-3"><p class="">
                                    <span class=""> 
                                 {{ $t('message.addPatient') }}
                                    </span></p>
                               
                                <div class="d-flex justify-content-center pt-1"><p class="">
                                    <span class="">
                                        <router-link class="font-weight-bold pb-4"  id="disabled-wrapper"  :to="{ name: 'add-patient-souscripteur', params:{id: value.id, texte:value.type_contrat.description_fr} }">
                                            <button class="btn btn-primary text-white border-primary rounded">
                                           <i class="fas fa-plus-circle p-2"></i>
                                            {{ $t('message.addWebPatient') }}</button>
                                        </router-link>
                                    </span></p>
                                </div> 
                            </div> 
                                <div class="list-group-item d-flex justify-content-center py-2"><p class="">
                                    <span class=""> 
                                        <b-link class="font-weight-bold" @click="GenerationFacture(value)">
                                            <button class="btn btn-outline-dark rounded" >
                                                <i class="fa fa-print p-2"></i> {{ $t('message.voirrecu') }}
                                            </button>
                                        </b-link>
                                    </span></p>
                                </div> 
                            </div>
                       
                                </div>
                                </div>
                            </b-collapse>
                                </div>
                                <div v-else>
                                <div v-b-toggle="'collapse'+index" class="trajet__info mt-1 transparentGrey w-100"> 
                                    <span class="border border-5 rounded py-1 px-1 row  cimdashboard">
                                        
                                        <div class="col-6 text-default"> <h5 class="font-weight-light colorGrey">{{truncate(value.type_contrat.description_fr, 25) }}</h5>
                                            <!-- <h5 class="font-weight-light colorGrey"><i class="fa fa-circle-red" aria-hidden="true"></i>{{value.nombre_restant}}/{{value.nombre_paye}}</h5> -->
                                        </div>
                                        <div class="col-6 pt-1">
                                                <span class="border border-secondary spanGrey rounded py-1 px-3 float-right">Complet</span>
                                        </div>
                                    </span>
                                </div>
                            <b-collapse :id="'collapse'+index" class="">
                                    <div>
                                        <div class="py-1">

                                    <div class="mt-3 card-body shadow">
                                        <div class="list-group-item"><p class="ligne pt-3"><span class="new-title">Produits</span>: <span class="font-weight-bold text-gray float-right">{{ value.type_contrat.description_fr.length > 21 ? value.type_contrat.description_fr.substring(0, 21)+' ...' : value.type_contrat.description_fr }}</span></p></div>
                                        <div class="list-group-item"><p class="ligne"><span class="new-title">Nombre payé</span><span class="font-weight-bold text-gray float-right">{{value.nombre_paye}}</span></p></div>
                                        <div class="list-group-item"><p class="ligne"><span class="new-title">Nombre restant</span>: <span class="font-weight-bold text-gray float-right">{{value.nombre_restant}}</span></p></div>
                                        <div class="list-group-item"><p class="ligne"><span class="mr-2 new-title">Montant unitaire: </span><span class="font-weight-bold text-gray float-right">{{value.type_contrat.montant}}</span></p></div>
                                        <div class="list-group-item"><p class="ligne"><span class="new-title">Date de création</span>: <span class="font-weight-bold text-gray float-right">{{ new Date(value.created_at).toLocaleString().split(",")[0] }}</span></p></div>
                                        <div class="list-group-item d-flex justify-content-center py-2"><p class="">
                                            <span class=""> 
                                                <b-link class="font-weight-bold" @click="GenerationFacture(value)">
                                                    <button class="btn btn-outline-dark rounded" >
                                                        <i class="fa fa-print p-2"></i> {{ $t('message.voirrecu') }}
                                                    </button>
                                                </b-link>
                                            </span></p>
                                        </div> 
                                    </div>
                       
                                </div>
                                </div>
                            </b-collapse>
                            </div>
                            </div>
                        </div>
                    </b-row>
                </b-container>
            </div>
        </div>
 
    
        <div class="bg-loader d-none" id="bg-loader">
            <div class="spinner-border mt-5 loader" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-3 attente">{{$t('message.wait')}}</p>
        </div>

        <b-modal id="consentement" size="md" centered title="Signature du consentement éclairé" :hide-footer="true" v-if="consentements">
            <div class="row">
                <div class="col-md-12">
                    <p>Consulter le <a style="color: #2dcecc;" target="_blank" href="https://www.medicasure.com/particuliers/consentement-eclaire">Consentement éclairé</a> et apporter votre signature ci-dessous</p>
                </div>
                <div class="col-md-12 mb-2">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" value="1" v-model="consentement" id="consentement_eclaire" name="consentement">
                        <label class="custom-control-label" for="consentement_eclaire">Je valide le consentement éclairé</label>
                    </div>
                </div>
                <div class="col-md-12 border w-100 h-100" v-if="consentement">
                    <img :src="dataUrl" class="img-fluid" v-if="dataUrl!= null && !disabled">
                    <vueSignature v-else ref="signature" :sigOption="option" :w="'350px'" :h="'300px'"></vueSignature> 
                </div>
            </div>
            <div class="col-md-12 text-center">
                <button @click="save" class="btn btn-primary">Enregistrer</button>
                <button @click="clear" class="btn btn-secondary">Modifier</button>
                <button @click="undo" class="btn btn-danger">Effacer</button>
            </div>
            <template #modal-footer></template>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import _ from 'lodash';
    //import SlimSelect from 'slim-select';
    import moment from "moment";
    import { required, email,integer, minLength } from 'vuelidate/lib/validators';
    
    import axios from 'axios';
    import Swal from 'sweetalert2';
    import Vue from 'vue';
    import AppConfig from '../../constants/AppConfig';
    
    import oldSubcriber from './oldSubcriber.vue';
    import vueSignature from "vue-signature";
    import WelcomeMedsurlink from './WelcomeMedsurlink.vue';
    
    export default {
        name: "SouscripteurDashboard",
        components:{
    vueSignature,
    WelcomeMedsurlink,
    oldSubcriber
},
        data: () => ({
            moment: moment,
        }),
        computed: {
            ...mapGetters(["subscriber", 'hasAdminRole', "countries",
                'hasGestionnaireRole','hasSouscripteurRole','hasMedecinControleRole','hasPraticienRole','hasAssistante',
                "patients","commandes","all_commandes"]),
            mSubscriber: function() {
                return this.subscriber;
            },

            ifRestant: function (){
                   if( !_.isUndefined(this.commandes) && !_.isNull(this.commandes)){
                let plusRestant=false;
               // console.log(this.commandes);
                _.forOwn(this.commandes, function(value) {
                    
                    if(value.nombre_restant>0){
                       plusRestant=true;
                        }
                     });
                     
                     return plusRestant;
                    }
                    
                },
            mCommandes: function (){
                let restant = [];
                if( !_.isUndefined(this.commandes) && !_.isNull(this.commandes)){
                  restant = this.commandes;
                }

                return restant;
            },
            mCountries: function() {
                let cArray = [];

                _.forOwn(this.countries, function(value, key) {
                    cArray.push({ text: value.name, value: value.name });
                });

                return cArray;
            },
            mAffiliate:function(){
                let pArray = [];
                _.forEach(this.patients, function(patient) {
                    let p = {};

                    if (typeof patient.user == 'object') {
                        if (!_.isUndefined(patient.dossier)){
                            if (!_.isNull(patient.dossier)){
                                p.nom = (patient.user.prenom ? ' ' + patient.user.prenom : '') + "  " + (patient.user.nom).toUpperCase() ;
                                p.dossier = patient.dossier.numero_dossier;
                                p.email = patient.user.email;
                                p.telephone = patient.user.telephone;
                                p.age = patient.age;
                                p.nationalite = patient.user.nationalite;
                                p.ville = patient.user.ville;
                                p.pays = patient.user.pays;
                                p.date = moment(patient.user.date_de_naissance).format('DD-MM-YYYY');
                                p.id = patient.user.id;
                                p.slug = patient.user.slug;
                                p.adresse = patient.user.adresse;
                                p.fileSlug = patient.dossier.slug;
                                pArray.push(p);
                            }
                        }
                    }
                });
                return pArray;
            },

            mSubscriberUserInformation:function(){
                if (typeof this.mSubscriber.user == 'object'){
                    return this.mSubscriber.user;
                }
                return [];
            },

            fullName:function () {
                let prenom  = this.mSubscriberUserInformation.prenom != null ? this.mSubscriberUserInformation.prenom : "";
                return this.getValue(prenom) + "  " + (this.getValue(this.mSubscriberUserInformation.nom)).toUpperCase();

            },

            rows: function() {
                if(typeof  this.mSubscriber.patients == "object")
                    return this.mSubscriber.patients.length;
                return 0;
            },

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

        },

        data() {
            return {
                alertForm: false,
                Home: false,
                mobileView: true,
                consentements:true,
                oldSubscribers:true,
                newSubscribers:false,
                rotate: false,
                nbre_restant: 2,
                option:{
				    penColor:"rgb(0, 0, 0)",
                    backgroundColor:"rgb(255,255,255)"
                },
                disabled: JSON.parse(localStorage.getItem('user'))['signature'] == null ? true : false,
                dataUrl: JSON.parse(localStorage.getItem('user'))['signature'],
                consentement: 1,
                form: this.subscriber != null ? this.subscriber : {user: JSON.parse(localStorage.getItem('user')), sexe: JSON.parse(localStorage.getItem('user'))['souscripteur']['sexe']},
                sexes: [
                    { value: 'F', text: this.$i18n.t('message.female') },
                    { value: 'M', text: this.$i18n.t('message.male') }
                ],
                subscriber_id: JSON.parse(localStorage.getItem('user'))['slug'],
                signature: JSON.parse(localStorage.getItem('user'))['signature'],
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled: {enabled: true},

                sort: {
                    enabled: true,
                    initialSortBy: {field: 'date', type: 'desc'}
                },
                affiliateColumns: [
                    {
                        label: this.$i18n.tc('message.patients', 1),
                        field: 'type_contrat.description_fr',
                    },
                    {
                        field: 'nombre_restant',
                        label: this.$i18n.t('message.fileNumber')
                    },
                    {
                        field: 'type_contrat.montant',
                        label: this.$i18n.t('message.old')
                    },
                    {
                        field: 'created_at',
                        label: this.$i18n.t('message.email')
                    },
                ],
            }
        },

        methods: {
            truncate(str, n){
                return (str.length > n) ? str.slice(0, n-1) + '...' : str;
            },
            handleView() {
                this.mobileView = window.innerWidth <= 990;
            },

            checkIfProfileComplete(){
                let user = JSON.parse(localStorage.getItem('user'));
                
                if(user.souscripteur.sexe == ''){
                    let newSubscriber=true;
                    this.newSubscribers=newSubscriber;
                    }
                if(this.dataUrl == null){
                    
                    let consentement=true;
                    this.consentements=consentement;
                    this.$bvModal.show('consentement');
                }
        
            },
            
            goToPaiement :function(){

               this.$router.push({ name: 'paiement', params: { identifiant: (JSON.parse(localStorage.getItem('user')))['slug'] } });

            },

            gotToMesAffilies: function() {

                this.$router.push({ name: 'mesAffilies'});
                
            },

            addPatientToAffiliation: function() {
                let offres = [];
                if( !_.isUndefined(this.commandes) && !_.isNull(this.commandes)){
                _.forOwn(this.commandes, function(value) {
                    if(value.nombre_restant >=0){
                        offres.push({ text: value.type_contrat.description_fr, value: value.id, id: value.type_contrat.offre_id});
                        
                    }
                });
                this.$router.push({ name: 'add-patient-souscripteur', params:{id: offres.id}});//params:{id: this.commandes.type_contrat.offre_id}
                
                }
                
                
            },

            GenerationFacture: affiliation => {
                axios.get(`${AppConfig.apiUrl}/impression/facture-offre/${affiliation.id}`).then(res => {
                    window.open(res.data.link, '_blank');
                }).catch(error => {
                    console.log('error ', error);
                })
            },

            getPatients() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };
                
                this.$store.dispatch('getPatients', { args : args });
            },

            onaffiliateRowClick(params){
                // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                this.$router.push((this.$router.resolve({ name: 'medical-file',  params: { file: params.row.fileSlug } })).href +  '#generale');

            },
           onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        subscriber: this.form.user.slug,
                        sexe: this.form.sexe,
                        nom: this.form.user.nom,
                        prenom: this.form.user.prenom,
                        telephone: this.form.user.telephone,
                        ville: this.form.user.ville,
                        pays: this.form.user.pays,
                        adresse: this.form.user.adresse,
                        quartier: this.form.user.quartier,
                        code_postal: this.form.user.code_postal
                    };

                    let successMessage = this.$i18n.t('message.subscriberUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };
                    let loader = document.getElementById('bg-loader');
                    loader.classList.remove("d-none");
                    this.$store.dispatch('updateSubscriber', { args, errorMessages, successMessage }).then(() => {
                        loader.classList.add("d-none");
                        this.$bvModal.hide('modal-scoped');
                        this.$router.push({ name: 'SouscripteurDashboard', params: { } });
                        Swal.fire({
                            icon: 'success',
                            title:"Mise à jours",
                            text:"Vos informations d'identifications ont été envoyé par email à l'adresse "+JSON.parse(localStorage.getItem('user'))['email']
                        });
                    });
                }
            },
            getSubscriber() {
                let args = {
                    subscriber: this.subscriber_id
                };

                this.$store.dispatch("getSubscriber", { args });
            },

            getValue(item){
                if (typeof item != "undefined"){
                    return item;
                }else{
                    return "";
                }
            },
            getCountries: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getCountries', { args, errorMessages });
            },
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            getCommandes: function() {
                let args = {
                    souscripteur: (JSON.parse(localStorage.getItem('user')))['id']
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };
                this.$store.dispatch('getCommandes', { args, errorMessages });
                if(this.$store.dispatch('getCommandes', { args, errorMessages })){
                 
                }
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            },
            /**
             * signature
             */
            
          
            save(){
                var _this = this;
                const formData = new FormData();
                //if((this.dataUrl!= null) && (!this.dataUrl.includes(".png"))){
                    const signature = _this.$refs.signature.save();
                    formData.append('signature', signature)
                //}
                formData.append('id', JSON.parse(localStorage.getItem('user'))['id'])
                formData.append('consentement', this.consentement ? 1 : 0)
                formData.append('souscripteur', 1)

                axios.post(`${AppConfig.apiUrl}/signature/user`, formData, {
                    headers: {
                        'content-type': 'multipart/form-data',
                        'Authorization': "Bearer " + localStorage.getItem('ms-token')
                    }
                }).then(res => {
                    this.$bvModal.hide('consentement');
                    Vue.swal("Votre signature a été ajouter avec succès", '', 'success');
                    let user = JSON.parse(localStorage.getItem('user'));
                    user = {...user, signature: res.data.signature};
                    localStorage.setItem("user", JSON.stringify(user));
                    this.disabled = false;
                    this.dataUrl = res.data.signature;
                }).catch(error => {
                    console.log('error ', error);
                })

            },
            clear(){
                var _this = this;
                this.disabled = true;
                _this.$refs.signature.clear();
            },
            undo(){
                var _this = this;
                _this.$refs.signature.undo();
            }
        },

        validations: {
            form: {
                user: {
                    nom: {
                        required
                    },
                    prenom: {
                        required
                    },
                    telephone: {
                        required,
                        integer,
                        minLength: minLength(9)
                    },
                    email: {
                        required,
                        email
                    },
                    nationalite: {
                    },
                    ville: {
                        required
                    },
                    pays: {
                        required
                    },

                    quartier: {
                        required
                    },

                    code_postal: {
                        required
                    },
                    adresse: {
                        required
                    }
                },
                sexe: {
                    required
                },
                date_de_naissance: {
                    // required
                }
            }
        },
        created() {
            this.handleView();
            window.addEventListener('resize', this.handleView);
        },
        mounted() {
            this.getCommandes();
            this.checkIfProfileComplete();
            this.getSubscriber();
            this.getPatients();
            this.getCountries();
          
        }

    }
</script>
<style>
.modal-backdrop {
    display: none !important;
}
#modal-scoped___BV_modal_backdrop_{
    display: none !important;
}
.link {
    font-size: 1.2rem;
}
.overflow-ellipsis {
    text-overflow: ellipsis;
}
</style>